module.exports = __webpack_public_path__ + "static/img/img_none.8bacb03.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/train/img_none.png
// module id = kNd6
// module chunks = 1